/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  RejectedData : null
};

const reducer = (state = initialState, action = {}) => {

  switch (action.type) {
    case actions.SendRejectionAction.REQUEST_SEND_REJECT:
      return {
        ...state,
    };
    case actions.SendRejectionAction.REJECTION_RESPONSE_RECEIVED:
          return{
      ...state,
      RejectedData : action.data.StatusCode,
    };

    default:
      return state;
  }
};

export default reducer;
